const EXPORT = '/sales/cobranzas/report'

export const salesCobranzasEndpoints = {
  EXPORT,
}
